import React, { useEffect, useState } from 'react'
import { postLiquidacionDescripcion } from '../../../services/PaginaRuta'
import ModalLiquidarUnProcedimiento from './ModalLiquidarUnProcedimiento'

const TablaLiquidacionProcedimientoCirugia = ({item,dataUser}) => {
    const [nombreProcedimiento, setnombreProcedimiento]=useState('')
    const [modalOnLiquidarUnProcedimiento, setmodalOnLiquidarUnProcedimiento]=useState(false)
    useEffect(()=>{
        const nombre={
            PRCODI: item.CrgCod
        }
        postLiquidacionDescripcion(nombre).then((res)=>{
            setnombreProcedimiento(res.data[0].PrNomb)
        })
    },[])
    const handleOnclickLiquidarProcedimiento=()=>{
        setmodalOnLiquidarUnProcedimiento(true)
    }
  return (
    <tbody>
    <tr className="divide-y divide-slate-700">
        <td></td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4 whitespace-pre-wrap">
          <button type="button"
                onClick={handleOnclickLiquidarProcedimiento}
                className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
                Seleccionar
              </button>
          </td>
          
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
            {/* {item.MPCedu? item.MPCedu:null} */}
            {item.CrgCod}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
            {/* {item.MPNOMC? item.MPNOMC:null} */}
            {nombreProcedimiento}
          </td>
          
          
        </tr>
        {modalOnLiquidarUnProcedimiento? <ModalLiquidarUnProcedimiento setmodalOnLiquidarUnProcedimiento={setmodalOnLiquidarUnProcedimiento} nombreProcedimiento={nombreProcedimiento} codigoProcedimiento={item.CrgCod} dataUser={dataUser}/>:null}
        </tbody>
  )
}

export default TablaLiquidacionProcedimientoCirugia